import { render, staticRenderFns } from "./MpTextSelectV2.vue?vue&type=template&id=3c67154e&scoped=true&"
import script from "./MpTextSelectV2.vue?vue&type=script&lang=js&"
export * from "./MpTextSelectV2.vue?vue&type=script&lang=js&"
import style0 from "./MpTextSelectV2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MpTextSelectV2.vue?vue&type=style&index=1&id=3c67154e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c67154e",
  null
  
)

export default component.exports